import { createApi } from '@reduxjs/toolkit/query/react';
import { TServerResponse } from 'app/types/server-response';
import { transportAPIBase } from 'app/utilities/env';
import getBaseQueryWithLogout from 'app/utilities/getBaseQuery';

import { TBlog } from '../types/blog';

export const blogsApiSlice = createApi({
  reducerPath: 'blogsApi',
  tagTypes: ['Blogs', 'Blog'],
  baseQuery: getBaseQueryWithLogout(`${transportAPIBase}/blogs`),
  endpoints: (build) => ({
    getPublishedBlogs: build.query<TBlog[], void>({
      query: () => '/published',
      transformResponse: (res: TServerResponse<TBlog[]>) => res.data,
      providesTags: ['Blogs'],
    }),

    getBlog: build.query<TBlog, number>({
      query: (id) => `/${id}`,
      transformResponse: (res: TServerResponse<TBlog>) => res.data,
      providesTags: ['Blog'],
    }),

    incrementBlogViews: build.mutation<unknown, number>({
      query: (id) => ({
        url: `/${id}/increment-views`,
        method: 'PUT',
      }),
      transformResponse: (res: TServerResponse<unknown>) => res.data,
      invalidatesTags: ['Blog', 'Blogs'],
    }),
  }),
});

export const {
  useGetBlogQuery,
  useGetPublishedBlogsQuery,
  useIncrementBlogViewsMutation,
  useLazyGetBlogQuery,
  useLazyGetPublishedBlogsQuery,
} = blogsApiSlice;
